import ErrorPayment from 'components/Patient/checkin/SecurePayment/ErrorPayment';

import { usePaymentContextApi } from '../context/PaymentContext';

const ErrorPaymentModal = ({ message, onClearError = () => {}, onClose = () => {} }) => {
  const { closeModal } = usePaymentContextApi();

  const handleClearError = () => {
    closeModal();
    onClearError(null);
    onClose();
  };
  return (
    <ErrorPayment message={message} onTryAgain={handleClearError} onClose={handleClearError} />
  );
};

export default ErrorPaymentModal;
